<button type="button" class="btn" title="Filter Mine Sites" [class.btn-warning]="filterApplied" [class.btn-primary]="!filterApplied" (click)="showFilters()">
    <span data-toggle="tooltip" class="fa fa-filter fa-lg"></span>
</button>

<div bsModal #minesiteFilter="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog" style="width: 1000px;">
        <div class="modal-content">
            <form (ngSubmit)="applyFilter()">
                <div class="modal-header">
                    <button type="button" class="close" (click)="close()" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">Filter Mine Sites</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Mine Site</label>
                                </div>
                                <input type="text" class="form-control" name="MinesiteFilterName" placeholder="Mine Site Name" [(ngModel)]="name" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Model</label>
                                </div>
                                <select name="selectedModels" class="form-control" size="5" multiple="multiple" [(ngModel)]="selectedModels">
                                    <option *ngFor="let model of models" [value]="model.Id">{{ model.Name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Serial</label>
                                </div>
                                <select name="selectedEquipment" class="form-control" size="5" multiple="multiple" [(ngModel)]="selectedEquipment">
                                    <ng-container *ngIf="live">
                                        <option *ngFor="let equipment of equipment" [value]="equipment.Id">{{ equipment.Serial }}</option>
                                    </ng-container>
                                    <ng-container *ngIf="!live">
                                        <option *ngFor="let equipment of equipment" [value]="equipment.Equipment_ID">{{ equipment.Serial }}</option>
                                    </ng-container>

                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Powerd By</label>
                                </div>
                                <select name="selectedPowereBys" class="form-control" size="5" multiple="multiple" [(ngModel)]="selectedPoweredBys">
                                    <option *ngFor="let poweredBy of poweredBys" [value]="poweredBy.Id">{{ poweredBy.Name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Classification</label>
                                </div>
                                <select name="selectedClassifications" class="form-control" size="5" multiple="multiple" [(ngModel)]="selectedClassifications">
                                    <option *ngFor="let classification of classifications" [value]="classification.Id">{{ classification.Name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Status</label>
                                </div>
                                <div class="btn-group btn-group-justified">
                                    <div class="btn-group">
                                        <button type="button" class="btn" [class.btn-success]="activeMinesites" [class.btn-warning]="!activeMinesites" (click)="activeMinesites = !activeMinesites">
                                            {{ activeMinesites ? 'Hide' : 'Show' }} Active Mine Sites
                                        </button>
                                    </div>
                                    <div class="btn-group">
                                        <button type="button" class="btn" [class.btn-success]="inActiveMinesites" [class.btn-warning]="!inActiveMinesites" (click)="inActiveMinesites = !inActiveMinesites">
                                            {{ inActiveMinesites ? 'Hide' : 'Show' }} Inactive Mine Sites
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" *ngIf="filterApplied" (click)="clearFilter()">Clear Filter</button>
                    <button type="submit" class="btn btn-default">Apply Filter</button>
                </div>
            </form>
        </div>
    </div>
</div>